import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from 'data/redux/actions'

import { useUser } from './use-user'

export const useGroupData = (gameId, eventId, groupId) => {

  const dispatch = useDispatch()
  const { userId } = useUser()

  const game = useSelector(state => ((state?.user?.gameData|| {})[gameId] || {}) )
  const event = (game?.events || {})[eventId]
  const group = (event?.groups || {})[groupId]

  useEffect(() => {

    if (group) return
    refresh()

  }, [gameId, eventId, groupId])


  const refresh = () => {

    if (!gameId || !eventId || !groupId) return
    dispatch(actions.groupDataLoad(userId, gameId, eventId, undefined, groupId))
  }

  return {
    refresh,

    name: group?.name,
    level: group?.level,
    members: group?.members || {},
    // members: Object.values(group?.members || {})
  }
}
